
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PoliticaCookies from "../pages/politica-cookies/page";
import PoliticaPrivacidade from "../pages/politica-privacidade/page";
import TermosCondicoes from "../pages/termos-condicoes/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/politica-cookies",
    element: <PoliticaCookies />,
  },
  {
    path: "/politica-privacidade",
    element: <PoliticaPrivacidade />,
  },
  {
    path: "/termos-condicoes",
    element: <TermosCondicoes />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
